export default "__VITE_ASSET__CbrI$Ta3__"